import script from "./VTableSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./VTableSummary.vue?vue&type=script&setup=true&lang=js"

import "./VTableSummary.vue?vue&type=style&index=0&id=380f989e&scoped=true&lang=less"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-380f989e"]])

export default __exports__